<template>
    <footer :style="{ backgroundColor: backgroundColor, color: textColor }">
        <div class="cgu" :style="{borderTop: borderTop}">
            <a href="#/mentions"><p>Mentions Légales</p></a>
            <p>
                <span class="ffsystem">©</span>
                <span class="ffsystem">2</span>
                <span class="ffsystem">0</span>
                <span class="ffsystem">2</span>
                <span class="ffsystem">3</span>
                <span class="ffsystem">-</span>
                <span class="ffsystem">2</span>
                <span class="ffsystem">0</span>
                <span class="ffsystem">2</span>
                <span class="ffsystem">4</span>
                M&S Agency
            </p>
            <a href="#/cgu"><p>Conditions d'utilisation</p></a>
        </div>
    </footer>
</template>
  
<script setup>
import AOS from 'aos';
import 'aos/dist/aos.css';
import { defineProps } from 'vue';

const props = defineProps({
    backgroundColor: {
        type: String,
        required: false,
        default: 'var(--bgBlack)',
    },
    textColor: {
        type: String,
        required: false,
        default: 'var(--textBlack)',
    },
    borderTop: {
        type: String,
        required: false,
        default: '1px solid rgba(0, 0, 0, 0.1)',
    }
});


AOS.init();

</script>
<style scoped lang="scss">
footer {
    padding: 3rem 0;
    position: relative;
    font-family: 'Roboto';
    font-size: 20px;
    overflow: hidden;
}

.cgu {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    margin-top: 5rem;
    padding: 20px 20px 20px 20px;
    display: flex;
    gap: 30px;
    flex-direction: row;
    justify-content: space-between;
    font-family: 'Roboto';
    width: 100%;
    font-size: 10px;
}

@media(max-width: 768px) {

    .container {
        flex-direction: column;
        gap: 2rem;
    }
    .footer-column {
        justify-content: center;
        align-items:center;
        gap: 2rem;
    }

    .cgu {
        font-size: 10px;
        bottom: 0%;
    }

    .contact-info {
        font-size: 16px;
    }
}
@media(max-width: 400px) {
    .cgu {
        font-size: 8px;
        bottom: 0%;
    }
}
</style>